import { SC } from '../helper/ServerCall';

export const settingsService = {
    getAgencyType,
    getCountries,
    getStatesPrimary,
    getStatesSecondary,
    getStates,
    getSalesRep,
    getAgencySalesRep,
    getProgramType,
    getProgramItem,
    getMainProgramType,
    getInvoicing,
    getSettingValue,
    getUserPreferences,
    storeUserPreferences,
    getSettingValueByModelAndId,
    storeSettingsData,
    updateSettingsData,
    getAllAddtionalItems,
    storeItem,
    getSingleAdditionalItem,
    updateAdditionalItem,
    deleteAdditionalService,
    getListTypes,
}
function getAgencyType() {
    return SC.getCall('getAgencyTypes');
}
function getCountries() {
    return SC.getCall('getAllCountries');
}
function getStatesPrimary(countryId) {
    return SC.getCall('getStatesForCountry/' + countryId);
}
function getStates(countryId, type) {
    return SC.getCall('getStatesForCountry/' + countryId + '/' + type);
}
function getStatesSecondary(countryId) {
    return SC.getCall('getStatesForCountry/' + countryId);
}
function getSalesRep() {
    return SC.getCall('getGtvSalesRepresentatives');
}

function getAgencySalesRep(id) {
    return SC.getCall('getAgencySalesRepresentatives/' + id);
}
function getProgramType() {
    return SC.getCall('getProgramTypes');
}
function getMainProgramType() {
    return SC.getCall('getMainProgramTypes');
}

function getProgramItem(programType) {
    return SC.getCall('getProgramItems/' + programType);
}
function getInvoicing() {
    return SC.getCall('getInvoiceStyles');
}

function getSettingValue(key, state_name) {
    if (state_name === undefined) {
        return SC.getCall('getSettingValue/' + key);
    } else {
        return SC.getCall('getSettingValue/' + key + '?state=' + state_name);
    }
}

function getUserPreferences() {
    return SC.getCall('getUserPreferences');
}

function storeUserPreferences(preferenceData) {
    return SC.putCall('updateUserPreferences', preferenceData);
}

function getSettingValueByModelAndId(modelName, modelId, key) {
    return SC.getCall(`getSettingValueByModelAndId/${modelName}/${modelId}/${key}`);
}

function storeSettingsData(settingsData) {
    return SC.postCall(`storeSettingsData`, settingsData);
}

function updateSettingsData(model_id, key, settingsData) {
    return SC.putCall(`updateSettingsData/${model_id}/${key}`, settingsData);
}

function getAllAddtionalItems(page,filter,sort,pageSize) {
    return SC.getCall(`additionalServices?page=${page}&filter=${filter}&sort=${sort}&pageSize=${pageSize}`);
}

function storeItem(data) {
    return SC.postCall(`additionalServices`, data);
}

function getSingleAdditionalItem(id) {
    return SC.getCall(`additionalServices/${id}`);
}

function updateAdditionalItem(data, id) {
    return SC.putCall(`additionalServices/${id}`, data);
}

function deleteAdditionalService(id) {
    return SC.deleteCall(`additionalServices/${id}`);
}

function getListTypes() {
    return SC.getCall('list_type');
}


// WEBPACK FOOTER //
// ./src/services/settings.js